import './index.css';
import 'overlayscrollbars/overlayscrollbars.css';
import "@/styles/react-toastify-reset.css";
import "@/styles/overlayscrollbars-reset.css";
import 'fotor-website-header/websiteHeaderNoCss.css';
import 'react-toastify/dist/ReactToastify.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from "@/locales";
import { getCookie, setCookie } from './utils';
import { I18nLangMap } from './constants';

const updateSeo = () => {
	const seoTitle = i18n.t("seo_title");
	const seoDesc = i18n.t("seo_desc");
	const title = document.head.querySelector("title");
	const description = document.head.querySelector("meta[name=description]");
	if (title) {
		title.textContent = seoTitle;
	}
	if (description) {
		description.setAttribute("content", seoDesc);
	}
}

let locale = getCookie('locale');
if (!locale) {
  locale = navigator.language;
  if (locale) {
    locale = locale.replace('-', '_');
  }
}
if (!locale) {
  locale = 'en_US';
}
setCookie('locale', locale);
const langKey = Object.keys(I18nLangMap).find(key => I18nLangMap[key] === locale) || 'en';

i18n.changeLanguage(langKey, () => {
  updateSeo();
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  );
});

i18n.on("languageChanged", updateSeo);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
